export { default as termToUrl } from './termToUrl';